import { useRef } from "react"
import { useParams } from "react-router"
import { Bound } from "lib/@components/binding/Bound"
import { BoundAutocomplete } from "lib/@components/binding/bound-components"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSave } from "lib/@hooks/use-save"
import { getScheduleDraft } from "../controller/get-schedule-draft"
import { getAuthoringScheduleTypes } from "authoring/routes/project/controller/get-authoring-schedule-types"
import { updateDraftLegacyScheduleTypes } from "../controller/update-draft-legacy-schedule-types"
import { SeedSource } from "authoring/lib/enum/seed-source.mjs"
import { useScheduleEditorSeed } from "../hooks/use-schedule-editor-seed"

export function ScheduleEditorLegacyScheduleTypes() {
    const { projectId, scheduleId } = useParams()
    const { editMode } = useBoundContext()
    const { seedSource } = useScheduleEditorSeed()
    const draftRecord = getScheduleDraft.useResultsOnce({ projectId, scheduleId })
    const scheduleTypes = getAuthoringScheduleTypes.useResultsOnce() ?? []
    const typeIds = scheduleTypes.map((t) => t.id)

    const stableRef = useRef({})
    const target = draftRecord ?? stableRef.current

    const onChange = useSave({ save: saveTypes, target, wait: 1000 })

    if (seedSource !== SeedSource.NEW) return null

    return (
        <Bound target={target} onChange={onChange}>
            <BoundAutocomplete
                field="legacyScheduleTypes"
                label="Schedule Types"
                multiple
                defaultValue={[]}
                disabled={!editMode}
                options={typeIds}
                getOptionLabel={(id) => scheduleTypes.find((t) => t.id === id)?.name ?? String(id)}
                isOptionEqualToValue={(option, value) => option === value}
            />
        </Bound>
    )

    async function saveTypes(record) {
        await updateDraftLegacyScheduleTypes({
            projectId,
            scheduleId,
            legacyScheduleTypes: record.legacyScheduleTypes ?? [],
        })
    }
}
